export class RichSet<T> extends Set<T> {
  intersect(other: Set<any>) {
    return new RichSet([...this].filter(x => other.has(x)))
  }

  difference(other: Set<any>) {
    return new RichSet([...this].filter(x => !other.has(x)))
  }
}